import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faSort} from '@fortawesome/free-solid-svg-icons';
import {SortOptionBase} from '../../../core/models/shared/sort-option-base.model';

@Component({
  selector: 'app-sort-dropdown',
  imports: [FaIconComponent],
  templateUrl: './sort-dropdown.component.html'
})
export class SortDropdownComponent {
  @Input() dropdownId = 'sortDropdown';
  @Input() label = 'Сортирај';
  @Input() options: SortOptionBase[] = [];
  @Input() selected?: SortOptionBase | null;
  @Output() selectedChange = new EventEmitter<SortOptionBase>();

  protected readonly faSort = faSort;
}
